import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "edition",
  "use": "edition-usage",
  "viewBox": "0 0 45 45",
  "content": "<symbol viewBox=\"0 0 45 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"edition\">\n<circle cx=\"22.5\" cy=\"22.5\" r=\"22.5\" fill=\"#DC3819\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.6449 17.883V17.8839L27.1156 21.3554L19.0156 29.4546H15.5449V25.983L23.6449 17.883ZM27.6941 14.9908L30.0087 17.3054C30.3281 17.6249 30.3281 18.1428 30.0087 18.4623L28.2726 20.1977L24.8018 16.727L26.5372 14.9908C26.8567 14.6714 27.3746 14.6714 27.6941 14.9908Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/edition.svg
// module id = 438
// module chunks = 0